<template>
  <router-link tag="h6" 
    :to="linkDestination" exact 
    :disabled="status == 'pending'"
    :event="status == 'pending' ? 'click' : ''"
  >            
    <div class="action"
      v-bind:class="{ 
        'action-pending': status=='pending'
      }"
    >
        <div class="action-check"
          v-bind:class="{ 
            'action-check-checked': status=='completed'
          }"
        ></div>
        <div class="action-text">{{ name }}</div>
        <div class="action-arrow"
          v-bind:class="{ 
            'action-arrow-pending': status=='pending'
          }"
        ></div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'ContainerAction',
  props: ['id', 'name', 'status'],
  data(){
    return {
      linkDestination: ''
    }
  },
  mounted () {
    this.setLinkDestination()
  },
  methods: {
    setLinkDestination: function () {
      switch (this.id) {
        case '002':
          this.linkDestination = '/createexpedient'
          break;
        case '003':
          // Naviera - Asignación de contenedor
          break;
        case '004':
          this.linkDestination = '/emptycontainer/transportista'
          break;
        case '005':
          this.linkDestination = '/pickuporder'
          break;
        case '006':
          this.linkDestination = '/pickupcontainer'
          break;
        case '007':
          // EVENT - Salida del puerto
          break;
        case '008':
          this.linkDestination = '/sealed'
          break;
        case '009':
          this.linkDestination = '/uploaddocs/cargador'
          break;
        case '010':
          // Naviera - Solicitud de entrada de mercancía peligrosa
          break;
        case '011':
          // Validador - Autorización entrada de mercancía peligrosa
          break;
        case '012':
          // EVENT - Entrada a terminal
          break;
        case '013':
          // EVENT - Llegada a pesaje
          break;
        case '014':
          this.linkDestination = '/uploaddocs/transportista'
          break;
        case '015':
          // EVENT - Contenedor posicionado
          break;
        case '016':
          this.linkDestination = '/uploaddocs/transitario'
          break;
        case '017':
          // Validador - Autorización levante
          break;
        case '018':
          // EVENT - Cargado en buque
          break;
        case '019':
          // Naviera - Registro Bill of Lading
          this.linkDestination = '/uploaddocs/transitarioBill'
          break;
      }
    }
  }
}
</script>

<style lang= "scss" scoped>
.action {
  height: 50px;
  width: 100%;
  margin-bottom: 4px;
  padding: 0 15px;
  background-color: #f0f0f0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
}
.action-pending {
  background-color: #65D0E6;
}
.action-check {
  width: 30px;
  height: 100%;
  background-repeat: no-repeat;
  background-position:left;
  background-size: 50%;
}
.action-check-checked {
  background-image: url('~@/assets/icons/icon-green-check.svg');
}
.action-text {
  flex: 1;
  font-size: 0.8em;
  font-weight: 600;
  color: #555555;
}
.action-arrow {
  width: 30px;
  height: 100%;
  background-image: url('~@/assets/icons/icon-action-arrow.svg');
  background-size: 50%;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.7;
}
.action-arrow-pending {
  background-image: url('~@/assets/icons/icon-action-arrow-blue.svg');
}
</style>
